import request from '@/utils/request'


// 查询用户血液成分检测记录列表
export function listBloodComponents(query) {
  return request({
    url: '/joe/user-blood-components/list',
    method: 'get',
    params: query
  })
}

// 查询用户血液成分检测记录分页
export function pageBloodComponents(query) {
  return request({
    url: '/joe/user-blood-components/page',
    method: 'get',
    params: query
  })
}

// 查询用户血液成分检测记录详细
export function getBloodComponents(data) {
  return request({
    url: '/joe/user-blood-components/detail',
    method: 'get',
    params: data
  })
}

// 新增用户血液成分检测记录
export function addBloodComponents(data) {
  return request({
    url: '/joe/user-blood-components/add',
    method: 'post',
    data: data
  })
}

// 修改用户血液成分检测记录
export function updateBloodComponents(data) {
  return request({
    url: '/joe/user-blood-components/edit',
    method: 'post',
    data: data
  })
}

// 删除用户血液成分检测记录
export function delBloodComponents(data) {
  return request({
    url: '/joe/user-blood-components/delete',
    method: 'post',
    data: data
  })
}
